import React, { Fragment } from 'react';

import { Col } from 'reactstrap';
import styled from 'styled-components';

import DocumentList from 'components/DocumentList';
import DocumentListItem from 'components/ModularBlocks/DocumentsBlock/components/DocumentListItem';

import { CategoryWithDocumentsI, DocumentSubcategoryTitle } from 'interfaces/content-stack/modular-blocks/documents';

const ListTitle = styled.h4`
  ${({ theme }) => `
    font-family: ${theme.fonts.fontFamilySecondary};
    color: ${theme.colors.primaryBlack};
  font-size: 1.25rem;
  font-weight: 600;
  text-transform: uppercase;

    @media (min-width: ${theme.breakpoints.md}) {
      font-size: 1.5rem;
    }
  `}
`;

interface DocumentColumnProps {
  data: CategoryWithDocumentsI[];
}

function DocumentColumn({ data }: DocumentColumnProps) {
  if (!data) {
    return null;
  }

  return (
    <Col sm={12} md={6}>
      {data.map((item, index) => {
        const { title } = item;
        const formattedTitle = DocumentSubcategoryTitle[title] ?? title.replaceAll(/-/g, ' ');

        return (
          <Fragment key={index}>
            {title && <ListTitle>{formattedTitle}</ListTitle>}
            <DocumentList>
              {item.docs.map((doc, index) => (
                <DocumentListItem key={index} document={doc} />
              ))}
            </DocumentList>
          </Fragment>
        );
      })}
    </Col>
  );
}

export default DocumentColumn;
